var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _g, _path154, _path155, _path156, _path157, _path158, _path159, _g2, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _g3, _path197, _path198;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBudgetStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 377,
    viewBox: "0 0 540 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M540 327.992H0V328.262H540V327.992Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M357.717 348.307H348.332V348.577H357.717V348.307Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187.077 334.882H162.043V335.152H187.077V334.882Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M495.471 340.671H434.268V340.941H495.471V340.671Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.341 340.671H46.1377V340.941H107.341V340.671Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.364 170.269L409.126 170.269V14.5002L122.364 14.5002V170.269Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.103 170.269L405.864 170.269V14.5002L119.103 14.5002V170.269Z",
    fill: "#F5F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M400.021 163.702V21.0669L124.956 21.0669V163.702L400.021 163.702Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.418 163.713L127.418 21.0776H124.956L124.956 163.713H127.418Z",
    fill: "#E6E6E6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M121.521 138.732L403.444 138.732V129.92L121.521 129.92V138.732Z",
    fill: "#F5F5F5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M121.521 63.8457L403.444 63.8457V55.0329L121.521 55.0329V63.8457Z",
    fill: "#F5F5F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.741 3.63525H415.498C415.736 3.6381 415.964 3.73493 416.132 3.90475C416.3 4.07458 416.394 4.30372 416.394 4.54246C416.394 4.7802 416.3 5.0082 416.131 5.17631C415.963 5.34441 415.735 5.43886 415.498 5.43886H112.741C112.502 5.43887 112.273 5.34478 112.103 5.17697C111.934 5.00917 111.837 4.78119 111.834 4.54246C111.837 4.30273 111.933 4.0736 112.103 3.90407C112.272 3.73454 112.501 3.63806 112.741 3.63525Z",
    fill: "#E6E6E6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.341 4.54268C107.341 5.43387 107.605 6.30501 108.101 7.04586C108.596 7.7867 109.3 8.36394 110.123 8.70448C110.947 9.04503 111.853 9.13358 112.727 8.95893C113.601 8.78428 114.403 8.35428 115.033 7.72336C115.662 7.09244 116.09 6.28896 116.263 5.41464C116.435 4.54032 116.345 3.63446 116.002 2.81172C115.66 1.98899 115.081 1.28637 114.339 0.792814C113.597 0.299253 112.725 0.0369383 111.834 0.0390755C111.243 0.0390737 110.658 0.155645 110.112 0.382104C109.566 0.608563 109.07 0.940463 108.653 1.3588C108.236 1.77714 107.905 2.2737 107.68 2.82004C107.455 3.36638 107.339 3.95177 107.341 4.54268Z",
    fill: "#E6E6E6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M407.916 9.57545C408.237 9.57545 408.544 9.44801 408.771 9.22117C408.998 8.99433 409.126 8.68666 409.126 8.36585V5.71986C409.126 5.39905 408.998 5.09138 408.771 4.86454C408.544 4.63769 408.237 4.51025 407.916 4.51025C407.594 4.51024 407.285 4.63734 407.057 4.86388C406.828 5.09042 406.698 5.39806 406.696 5.71986V8.33345C406.693 8.49553 406.722 8.65655 406.782 8.80712C406.842 8.95768 406.932 9.09479 407.045 9.21041C407.159 9.32603 407.294 9.41786 407.444 9.48053C407.593 9.54321 407.754 9.57548 407.916 9.57545Z",
    fill: "#E6E6E6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.36 9.57553C126.682 9.57554 126.99 9.44845 127.219 9.22191C127.447 8.99538 127.577 8.68772 127.58 8.36593V5.71993C127.569 5.4038 127.435 5.10438 127.208 4.88477C126.98 4.66516 126.676 4.54253 126.36 4.54273C126.199 4.5355 126.039 4.56036 125.888 4.61588C125.737 4.6714 125.598 4.75645 125.481 4.86606C125.363 4.97568 125.269 5.10764 125.203 5.25426C125.136 5.40087 125.1 5.55918 125.096 5.71993V8.33353C125.092 8.49973 125.121 8.6651 125.183 8.81931C125.246 8.97352 125.339 9.11327 125.457 9.22982C125.576 9.34637 125.717 9.43722 125.873 9.4967C126.028 9.55619 126.194 9.58302 126.36 9.57553Z",
    fill: "#E6E6E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M113.033 37.2451L403.456 37.2451V4.54272L113.033 4.54272V37.2451Z",
    fill: "#E0E0E0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M393.433 9.04626C395.921 9.04626 397.937 7.02994 397.937 4.54267C397.937 2.0554 395.921 0.0390625 393.433 0.0390625C390.946 0.0390625 388.93 2.0554 388.93 4.54267C388.93 7.02994 390.946 9.04626 393.433 9.04626Z",
    fill: "#E6E6E6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M319.562 327.992H337.986V204.828H319.562V327.992Z",
    fill: "#E6E6E6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M324.411 327.992H319.562V311.22H329.487L324.411 327.992Z",
    fill: "#F0F0F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M469.185 327.992H487.609V204.828H469.185V327.992Z",
    fill: "#E6E6E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M319.561 317.7H473.407V204.829H319.561V317.7Z",
    fill: "#F0F0F0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M323.319 240.771L469.648 240.771V209.818L323.319 209.818V240.771Z",
    fill: "#E6E6E6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M352.35 219.441H437.4C442.12 219.441 446.645 215.629 449.896 208.879H339.854C343.105 215.629 347.62 219.441 352.35 219.441Z",
    fill: "#F0F0F0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M468.569 327.992H473.408V311.22H463.482L468.569 327.992Z",
    fill: "#F0F0F0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M323.319 276.735H469.648V245.782L323.319 245.782V276.735Z",
    fill: "#E6E6E6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M352.35 255.405H437.4C442.12 255.405 446.645 251.582 449.896 244.843H339.854C343.105 251.582 347.62 255.405 352.35 255.405Z",
    fill: "#F0F0F0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M323.319 312.699H469.648V281.746H323.319V312.699Z",
    fill: "#E6E6E6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M352.35 291.358H437.4C442.12 291.358 446.645 287.535 449.896 280.796H339.854C343.105 287.535 347.62 291.358 352.35 291.358Z",
    fill: "#F0F0F0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M431.158 143.074C428.242 133.257 464.562 84.1387 480.503 85.6075C496.444 87.0763 468.418 146.66 459.81 151.93C450.101 157.881 434.333 153.755 431.158 143.074Z",
    fill: "#3CC64A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M429.074 157.233C427.67 152.222 453.06 144.068 463.148 149.975C473.235 155.883 452.639 171.1 446.948 170.409C440.457 169.631 430.607 162.687 429.074 157.233Z",
    fill: "#3CC64A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M459.918 152.74C463.428 146.152 437.573 107.672 423.792 106.959C410.011 106.246 427.712 151.239 434.506 155.851C442.184 161.089 456.084 159.901 459.918 152.74Z",
    fill: "#3CC64A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M446.666 132.264H446.612C445.957 132.253 445.32 132.481 444.82 132.904C444.32 133.327 443.99 133.916 443.89 134.564C440.897 154.866 440.534 175.47 442.81 195.865C442.886 196.514 443.195 197.114 443.68 197.553C444.164 197.992 444.792 198.24 445.446 198.252H445.5C445.882 198.257 446.26 198.181 446.611 198.029C446.961 197.877 447.275 197.651 447.531 197.368C447.788 197.085 447.981 196.751 448.098 196.387C448.215 196.024 448.253 195.639 448.21 195.26C446.041 175.315 446.4 155.175 449.28 135.32C449.333 134.943 449.306 134.559 449.2 134.194C449.094 133.829 448.911 133.49 448.664 133.201C448.416 132.912 448.11 132.679 447.766 132.517C447.421 132.355 447.046 132.269 446.666 132.264Z",
    fill: "#27AE60"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M444.69 204.818C454.237 204.818 462.283 199.202 464.238 191.588C464.716 189.555 465.4 187.575 466.279 185.68L466.43 185.367H422.949L423.1 185.68C423.979 187.575 424.663 189.555 425.142 191.588C427.096 199.202 435.153 204.818 444.69 204.818Z",
    fill: "#2771bb"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M422.863 187.279H466.56C467.78 187.279 468.839 186.091 469.141 184.384C469.573 181.933 468.299 179.557 466.56 179.557H422.863C421.124 179.557 419.85 181.933 420.293 184.384C420.595 186.08 421.653 187.279 422.863 187.279Z",
    fill: "#1379DF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M288.263 250.405H234.468V327.992H288.263V250.405Z",
    fill: "#F0F0F0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4873 327.992H234.479V250.404H74.4873V327.992Z",
    fill: "#F5F5F5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5387 310.809H122.364V276.368H88.5387V310.809Z",
    fill: "#FAFAFA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M134.46 310.809H168.285V276.368H134.46V310.809Z",
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M288.263 258.656H73.915V263.073H288.263V258.656Z",
    fill: "#E6E6E6"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M291.233 247.726H234.468V260.524H291.233V247.726Z",
    fill: "#F0F0F0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5173 260.514H234.479V247.716L71.5173 247.716V260.514Z",
    fill: "#F5F5F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M117.612 225.943C117.612 225.943 118.638 247.726 157.896 247.726C197.154 247.726 198.18 225.943 198.18 225.943H117.612Z",
    fill: "#F0F0F0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M117.612 211.514C117.612 211.514 118.638 233.297 157.896 233.297C197.154 233.297 198.18 211.514 198.18 211.514H117.612Z",
    fill: "#F0F0F0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M270 376.765C385.649 376.765 479.401 371.291 479.401 364.539C479.401 357.787 385.649 352.313 270 352.313C154.351 352.313 60.5986 357.787 60.5986 364.539C60.5986 371.291 154.351 376.765 270 376.765Z",
    fill: "#F5F5F5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M206.647 341.017H100.602V360.975H206.647V341.017Z",
    fill: "#fad504"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M206.647 341.017H100.602V343.285H206.647V341.017Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M112.547 341.017H108.367V360.975H112.547V341.017Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.137 341.017H117.957V360.975H122.137V341.017Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M131.738 341.017H127.559V360.975H131.738V341.017Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M141.329 341.017H137.149V360.975H141.329V341.017Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.919 341.017H146.739V360.975H150.919V341.017Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.52 341.017H156.341V360.975H160.52V341.017Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M170.11 341.017H165.931V360.975H170.11V341.017Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M179.701 341.017H175.521V360.975H179.701V341.017Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M189.303 341.017H185.123V360.975H189.303V341.017Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M198.893 341.017H194.713V360.975H198.893V341.017Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M202.338 321.059H96.293V341.017H202.338V321.059Z",
    fill: "#fad504"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M202.338 321.059H96.293V323.327H202.338V321.059Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.226 321.059H104.047V341.017H108.226V321.059Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M117.828 321.059H113.648V341.017H117.828V321.059Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M127.418 321.059H123.238V341.017H127.418V321.059Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.009 321.059H132.829V341.017H137.009V321.059Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M146.61 321.059H142.431V341.017H146.61V321.059Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.2 321.059H152.021V341.017H156.2V321.059Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.791 321.059H161.611V341.017H165.791V321.059Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M175.392 321.059H171.212V341.017H175.392V321.059Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M184.982 321.059H180.803V341.017H184.982V321.059Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M194.573 321.059H190.394V341.017H194.573V321.059Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M199.282 301.1H93.2363V321.059H199.282V301.1Z",
    fill: "#fad504"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M199.282 301.1H93.2363V303.368H199.282V301.1Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M105.182 301.1H101.002V321.059H105.182V301.1Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.771 301.1H110.592V321.059H114.771V301.1Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M124.373 301.1H120.193V321.059H124.373V301.1Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.963 301.1H129.783V321.059H133.963V301.1Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.554 301.1H139.374V321.059H143.554V301.1Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.155 301.1H148.976V321.059H153.155V301.1Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M162.745 301.1H158.565V321.059H162.745V301.1Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.336 301.1H168.156V321.059H172.336V301.1Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M181.936 301.1H177.757V321.059H181.936V301.1Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.527 301.1H187.348V321.059H191.527V301.1Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M204.087 281.152H98.042V301.111H204.087V281.152Z",
    fill: "#fad504"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M204.087 281.152H98.042V283.42H204.087V281.152Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M109.976 281.152H105.797V301.111H109.976V281.152Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M119.577 281.152H115.397V301.111H119.577V281.152Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.168 281.152H124.988V301.111H129.168V281.152Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M138.759 281.152H134.579V301.111H138.759V281.152Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.359 281.152H144.18V301.111H148.359V281.152Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.95 281.152H153.771V301.111H157.95V281.152Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.54 281.152H163.36V301.111H167.54V281.152Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M177.142 281.152H172.962V301.111H177.142V281.152Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M186.732 281.152H182.553V301.111H186.732V281.152Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M196.322 281.152H192.143V301.111H196.322V281.152Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3874 281.142H199.433V261.183H93.3874V281.142Z",
    fill: "#fad504"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.3874 263.451H199.433V261.183H93.3874V263.451Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M187.488 281.142H191.668V261.183H187.488V281.142Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M177.887 281.142H182.066V261.183H177.887V281.142Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.296 281.142H172.476V261.183H168.296V281.142Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M158.706 281.142H162.886V261.183H158.706V281.142Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M149.105 281.142H153.284V261.183H149.105V281.142Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.515 281.142H143.694V261.183H139.515V281.142Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.924 281.142H134.104V261.183H129.924V281.142Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.322 281.142H124.502V261.183H120.322V281.142Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.733 281.142H114.912V261.183H110.733V281.142Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M101.142 281.142H105.321V261.183H101.142V281.142Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M97.697 261.194H203.742V241.235H97.697V261.194Z",
    fill: "#fad504"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.697 243.503H203.742V241.235H97.697V243.503Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.797 261.194H195.977V241.235H191.797V261.194Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M182.218 261.194H186.397V241.235H182.218V261.194Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.616 261.194H176.796V241.235H172.616V261.194Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.015 261.194H167.194V241.235H163.015V261.194Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.436 261.194H157.615V241.235H153.436V261.194Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.834 261.194H148.014V241.235H143.834V261.194Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.233 261.194H138.413V241.235H134.233V261.194Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M124.653 261.194H128.833V241.235H124.653V261.194Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.053 261.194H119.232V241.235H115.053V261.194Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M105.451 261.194H109.631V241.235H105.451V261.194Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M100.754 241.236H206.799V221.277H100.754V241.236Z",
    fill: "#fad504"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.754 223.545H206.799V221.277H100.754V223.545Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M194.854 241.236H199.033V221.277H194.854V241.236Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M185.252 241.236H189.432V221.277H185.252V241.236Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M175.662 241.236H179.842V221.277H175.662V241.236Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.071 241.236H170.251V221.277H166.071V241.236Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.471 241.236H160.65V221.277H156.471V241.236Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M146.88 241.236H151.06V221.277H146.88V241.236Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.289 241.236H141.469V221.277H137.289V241.236Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M127.689 241.236H131.868V221.277H127.689V241.236Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M118.098 241.236H122.277V221.277H118.098V241.236Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.508 241.236H112.688V221.277H108.508V241.236Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M95.947 221.277H201.992V201.319H95.947V221.277Z",
    fill: "#fad504"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M95.947 203.587H201.992V201.319H95.947V203.587Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M190.048 221.277H194.228V201.319H190.048V221.277Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.468 221.277H184.647V201.319H180.468V221.277Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M170.866 221.277H175.046V201.319H170.866V221.277Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.266 221.277H165.445V201.319H161.266V221.277Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M151.686 221.277H155.865V201.319H151.686V221.277Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.085 221.277H146.265V201.319H142.085V221.277Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M132.483 221.277H136.663V201.319H132.483V221.277Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.904 221.277H127.084V201.319H122.904V221.277Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.303 221.277H117.482V201.319H113.303V221.277Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.701 221.277H107.881V201.319H103.701V221.277Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M375.894 294.934H371.455V360.976H375.894V294.934Z",
    fill: "#263238"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M414.73 258.948H410.291V360.975H414.73V258.948Z",
    fill: "#263238"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M454.28 283.42H449.841V360.975H454.28V283.42Z",
    fill: "#263238"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M371.465 294.934H340.34V360.976H371.465V294.934Z",
    fill: "#2771bb"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M340.34 294.934V334.094L355.892 294.934H340.34Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M410.292 258.948H379.166V360.975H410.292V258.948Z",
    fill: "#2771bb"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M379.166 258.948V298.109L394.729 258.948H379.166Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M449.852 283.42H418.727V360.975H449.852V283.42Z",
    fill: "#2771bb"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M418.727 283.42V318.272L434.289 283.42H418.727Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M267.927 355.576L259.578 354.01L260.993 334.256L269.341 335.833L267.927 355.576Z",
    fill: "#FFB573"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M324.108 355.348H315.608L313.502 335.682H321.991L324.108 355.348Z",
    fill: "#FFB573"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M314.917 354.366H325.263C325.432 354.367 325.596 354.425 325.727 354.531C325.858 354.637 325.95 354.784 325.987 354.949L327.672 362.509C327.71 362.693 327.708 362.883 327.663 363.066C327.618 363.248 327.533 363.418 327.414 363.563C327.295 363.709 327.144 363.825 326.974 363.904C326.803 363.984 326.617 364.023 326.43 364.021C323.092 363.967 320.662 363.762 316.472 363.762C313.891 363.762 306.104 364.032 302.54 364.032C298.976 364.032 298.512 360.511 299.97 360.187C306.514 358.761 311.439 356.785 313.534 354.906C313.912 354.56 314.405 354.367 314.917 354.366Z",
    fill: "#263238"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M259.75 352.173L268.898 353.75C269.063 353.779 269.214 353.863 269.326 353.988C269.438 354.114 269.504 354.273 269.513 354.441L269.881 362.163C269.89 362.35 269.857 362.536 269.785 362.708C269.712 362.88 269.602 363.034 269.461 363.157C269.321 363.281 269.155 363.371 268.975 363.421C268.795 363.472 268.606 363.481 268.423 363.448C265.183 362.822 260.398 361.807 256.262 361.094C251.413 360.262 249.047 359.658 243.367 358.675C239.932 358.081 240.677 354.355 242.179 354.258C248.972 353.955 251.369 354.992 257.623 352.476C258.29 352.179 259.027 352.074 259.75 352.173Z",
    fill: "#263238"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M288.835 95.4574C288.544 96.3214 288.317 96.9478 288.047 97.6174C287.777 98.287 287.507 98.9998 287.226 99.6802C286.664 101.052 286.07 102.391 285.444 103.73C284.193 106.418 282.79 109.032 281.243 111.56C278.076 116.969 273.952 121.756 269.071 125.687C267.712 126.723 266.267 127.641 264.751 128.43C264.362 128.646 263.963 128.829 263.552 129.013C263.142 129.197 262.775 129.369 262.289 129.553C261.331 129.905 260.345 130.173 259.34 130.352C257.709 130.627 256.059 130.768 254.405 130.773C252.85 130.773 251.359 130.773 249.89 130.633C244.161 130.176 238.492 129.149 232.967 127.566L233.82 121.248C239.22 121.043 244.696 120.87 249.836 120.416C251.122 120.297 252.385 120.146 253.584 119.963C254.682 119.814 255.765 119.575 256.824 119.25C257.17 119.151 257.503 119.013 257.818 118.839C258.174 118.623 258.66 118.418 259.06 118.137C259.94 117.582 260.774 116.958 261.554 116.269C263.277 114.741 264.831 113.032 266.188 111.171C267.666 109.198 269.016 107.131 270.227 104.983C271.49 102.823 272.624 100.523 273.737 98.2114C274.277 97.0558 274.817 95.8786 275.292 94.7014L276.016 92.941L276.674 91.2778L288.835 95.4574Z",
    fill: "#FFB573"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M284.742 85.4998C300.24 85.4998 283.208 118.98 283.208 118.98L263.434 110.977C263.434 110.977 268.834 99.3346 272.387 92.671C273.538 90.4134 275.316 88.5359 277.507 87.2638C279.699 85.9918 282.211 85.3793 284.742 85.4998Z",
    fill: "#2771bb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M284.742 85.4998C300.24 85.4998 283.208 118.98 283.208 118.98L263.434 110.977C263.434 110.977 268.834 99.3346 272.387 92.671C273.538 90.4134 275.316 88.5359 277.507 87.2638C279.699 85.9918 282.211 85.3793 284.742 85.4998Z",
    fill: "white"
  }))), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M280.951 96.3213C275.281 100.306 271.339 107.705 270.216 113.709L281.513 118.288C283.565 115.221 285.563 111.603 287.766 108.428C288.371 106.776 288.965 105.037 289.483 103.276L280.951 96.3213Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M238.679 122.058L231.886 118.224L226.681 127.944C229.687 128.452 232.764 128.375 235.742 127.717L238.679 122.058Z",
    fill: "#FFB573"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M225.384 118.224L221.604 126.799L226.637 127.976L231.843 118.224H225.384Z",
    fill: "#FFB573"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M260.992 334.267L260.269 344.441L268.617 346.007L269.341 335.833L260.992 334.267Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M321.991 335.692H313.491L314.593 345.834H323.082L321.991 335.692Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M327.002 89.2041C324.512 98.3705 322.707 107.709 321.602 117.144C320.792 123.721 320.317 129.996 320.015 135.698C319.302 149.047 319.604 159.22 319.205 162.698C312.563 162.244 287.539 160.538 273.845 159.544C267.678 111.236 279.461 86.3529 279.461 86.3529C283.029 85.6821 286.636 85.2312 290.261 85.0029C291.027 85.0029 291.816 84.9273 292.604 84.9165C299.047 84.992 305.48 85.4391 311.871 86.2557C313.081 86.3961 314.312 86.5797 315.5 86.7741C321.667 87.7245 327.002 89.2041 327.002 89.2041Z",
    fill: "#2771bb"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.002 89.2041C324.512 98.3705 322.707 107.709 321.602 117.144C320.792 123.721 320.317 129.996 320.015 135.698C319.302 149.047 319.604 159.22 319.205 162.698C312.563 162.244 287.539 160.538 273.845 159.544C267.678 111.236 279.461 86.3529 279.461 86.3529C283.029 85.6821 286.636 85.2312 290.261 85.0029C291.027 85.0029 291.816 84.9273 292.604 84.9165C299.047 84.992 305.48 85.4391 311.871 86.2557C313.081 86.3961 314.312 86.5797 315.5 86.7741C321.667 87.7245 327.002 89.2041 327.002 89.2041Z",
    fill: "white"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M315.565 101.43C315.479 108.381 317.427 115.206 321.17 121.064C321.3 119.768 321.451 118.461 321.613 117.144C322.218 112.197 322.996 107.078 324.022 101.905L315.565 101.43Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M311.569 64.3965C309.927 70.5201 307.919 81.7845 311.969 86.2233C309.92 88.0813 307.497 89.4777 304.862 90.318C302.228 91.1584 299.443 91.423 296.697 91.0941C291.373 90.6081 291.373 86.8605 292.701 84.8841C299.732 83.7177 299.905 78.5769 299.041 73.6737L311.569 64.3965Z",
    fill: "#FFB573"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M292.799 93.1138C292.924 94.0669 293.149 95.0044 293.468 95.9109C293.56 96.1997 293.742 96.4517 293.986 96.6303C294.231 96.809 294.526 96.905 294.829 96.9045C295.717 96.8916 296.603 96.9676 297.475 97.1314C297.659 97.1744 297.85 97.1793 298.035 97.1459C298.221 97.1125 298.398 97.0414 298.555 96.937C299.635 96.2566 301.018 95.2522 300.661 93.9994C300.24 92.5306 297.713 91.2021 297.713 91.2021C297.713 91.2021 293.371 92.2714 292.799 93.1138Z",
    fill: "#263238"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M295.077 95.9111C293.339 99.7127 289.321 124.056 288.824 127.739C288.327 131.422 290.023 137.362 292.377 142.081C295.084 138.37 296.625 133.938 296.805 129.348C297.119 124.315 297.421 96.5159 297.421 96.5159L295.077 95.9111Z",
    fill: "#263238"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M297.68 91.2022C299.287 92.5432 300.616 94.1872 301.589 96.0406C304.322 95.8246 316.385 90.5326 314.668 86.4502C313.167 86.029 311.849 85.165 311.428 85.6078C310.856 86.4826 305.736 89.5714 297.68 91.2022Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M297.68 91.2023C297.68 91.2023 293.047 92.7683 291.967 95.4035C289.17 94.1615 287.647 88.5563 290.12 84.8735C291.664 84.7439 293.144 83.9771 293.425 84.4847C293.857 85.4459 292.68 88.0271 297.68 91.2023Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M306.461 68.1875L299.041 73.6631C299.265 74.8055 299.384 75.9659 299.397 77.1299C302.065 76.9355 305.877 74.2895 306.374 71.5463C306.609 70.4415 306.639 69.3029 306.461 68.1875Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M293.576 44.7297C290.336 46.0041 289.138 58.5429 295.736 57.3117C302.335 56.0805 300.1 42.1701 293.576 44.7297Z",
    fill: "#263238"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M314.971 57.2687C312.325 65.2715 311.191 70.0883 305.985 73.1879C298.144 77.8427 289.083 71.4707 289.277 62.8415C289.45 55.0763 293.738 43.2827 302.561 42.1487C304.504 41.8858 306.482 42.1243 308.306 42.8414C310.131 43.5586 311.742 44.7306 312.985 46.246C314.229 47.7614 315.064 49.5697 315.412 51.4991C315.759 53.4285 315.607 55.4146 314.971 57.2687Z",
    fill: "#FFB573"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M311.968 62.7766C308.609 62.8414 305.855 52.6678 312.627 49.8166C307.292 49.201 290.908 50.0974 287.971 42.775C285.033 35.4526 296.427 34.3186 300.304 37.0834C299.073 33.055 304.084 27.115 313.091 32.515C322.099 37.915 321.991 44.5786 321.148 46.555C325.166 47.635 325.954 56.5774 321.515 57.7762C324.118 61.3834 321.872 68.965 314.852 67.345C314.614 71.7622 309.689 69.829 309.992 66.4378C310.294 63.0466 311.968 62.7766 311.968 62.7766Z",
    fill: "#263238"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M297 64.7313C297.949 65.009 298.951 65.0559 299.923 64.868C300.894 64.6802 301.806 64.263 302.583 63.6513C302.624 63.6091 302.646 63.553 302.646 63.4947C302.646 63.4364 302.624 63.3803 302.583 63.3381C302.543 63.2985 302.489 63.2764 302.432 63.2764C302.376 63.2764 302.321 63.2985 302.281 63.3381C301.563 63.9136 300.719 64.3114 299.818 64.4991C298.918 64.6868 297.985 64.659 297.097 64.4181C297.07 64.41 297.042 64.4075 297.014 64.4108C296.986 64.4142 296.959 64.4232 296.935 64.4374C296.91 64.4516 296.889 64.4706 296.873 64.4933C296.856 64.516 296.844 64.5419 296.838 64.5693C296.846 64.6094 296.865 64.6462 296.894 64.675C296.923 64.7039 296.96 64.7235 297 64.7313Z",
    fill: "#263238"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M316.645 65.7575C315.093 67.2058 313.032 67.9822 310.91 67.9175C308.102 67.7987 307.562 65.0771 309.063 62.8847C310.424 60.9083 313.513 58.5647 315.975 59.7635C316.511 60.0322 316.971 60.4305 317.313 60.9222C317.656 61.4138 317.87 61.9833 317.937 62.5788C318.003 63.1743 317.92 63.777 317.694 64.3322C317.469 64.8873 317.108 65.3772 316.645 65.7575Z",
    fill: "#FFB573"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M257.45 341.147L271.49 344.462C271.49 344.462 276.458 289.76 280.724 259.704C281.858 251.733 283.608 240.523 286.275 228.578C289.634 213.534 293.835 197.258 297.313 184.514C300.953 171.09 303.728 161.597 303.728 161.597L273.942 159.512C273.942 159.512 257.817 229.82 256.111 255.632C254.286 282.567 257.45 341.147 257.45 341.147Z",
    fill: "#263238"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M286.2 228.578C289.559 213.534 293.76 197.258 297.238 184.514L294.138 177.851C286.783 186.631 284.796 213.815 286.2 228.578Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M289.969 160.635C289.969 160.635 293.209 233.341 296.773 257.965C300.693 284.965 310.662 343.868 310.662 343.868H326.224C326.224 343.868 321.904 287.848 318.978 261.442C315.64 231.364 319.204 162.676 319.204 162.676L289.969 160.635Z",
    fill: "#263238"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M308.804 344.203H327.121L327.931 338.727L307.713 338.371L308.804 344.203Z",
    fill: "#2771bb"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M256.554 342.086L272.506 345.089L274.309 339.527L256.122 336.082L256.554 342.086Z",
    fill: "#2771bb"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M302.67 56.6315C302.486 57.2903 302 57.7115 301.59 57.6251C301.179 57.5387 300.942 56.8799 301.115 56.2211C301.287 55.5623 301.784 55.1411 302.195 55.2275C302.605 55.3139 302.843 55.9727 302.67 56.6315Z",
    fill: "#263238"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M295.174 54.666C295.001 55.3248 294.505 55.746 294.094 55.6488C293.684 55.5516 293.457 54.9144 293.63 54.2448C293.803 53.5752 294.299 53.1648 294.71 53.2512C295.12 53.3376 295.347 53.9964 295.174 54.666Z",
    fill: "#263238"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M296.837 55.2812C295.512 57.0973 293.946 58.7249 292.183 60.1196C293.057 61.5128 295.315 61.3941 295.315 61.3941L296.837 55.2812Z",
    fill: "#F0A460"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M304.992 54.4822C304.916 54.4775 304.844 54.4518 304.783 54.4078C304.722 54.3639 304.674 54.3035 304.646 54.2338C304.464 53.7619 304.173 53.3394 303.798 52.9999C303.423 52.6605 302.974 52.4136 302.486 52.279C302.434 52.2691 302.385 52.249 302.341 52.22C302.297 52.1911 302.259 52.1537 302.229 52.1101C302.2 52.0664 302.179 52.0174 302.168 51.9658C302.158 51.9142 302.157 51.861 302.167 51.8092C302.177 51.7574 302.197 51.7081 302.226 51.6641C302.255 51.6201 302.293 51.5822 302.336 51.5526C302.38 51.523 302.429 51.5023 302.481 51.4917C302.532 51.481 302.585 51.4807 302.637 51.4906C303.256 51.6485 303.828 51.9526 304.306 52.3772C304.783 52.8019 305.152 53.3349 305.38 53.9314C305.402 53.9802 305.413 54.0328 305.413 54.0861C305.414 54.1393 305.404 54.1921 305.384 54.2415C305.364 54.2908 305.334 54.3355 305.296 54.3732C305.258 54.4108 305.214 54.4405 305.164 54.4606C305.109 54.4811 305.05 54.4885 304.992 54.4822Z",
    fill: "#263238"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M292.01 50.9076C291.926 50.898 291.847 50.8642 291.783 50.8104C291.745 50.7732 291.714 50.7287 291.694 50.6795C291.673 50.6304 291.662 50.5776 291.662 50.5242C291.662 50.4709 291.673 50.4181 291.694 50.3689C291.714 50.3197 291.745 50.2752 291.783 50.238C292.187 49.7433 292.704 49.3528 293.29 49.0991C293.877 48.8454 294.515 48.736 295.152 48.78C295.256 48.7985 295.35 48.8554 295.414 48.9394C295.478 49.0234 295.508 49.1284 295.498 49.2336C295.482 49.3388 295.426 49.4336 295.341 49.4981C295.256 49.5625 295.15 49.5916 295.044 49.5792C294.54 49.5563 294.036 49.6518 293.575 49.8581C293.114 50.0644 292.707 50.3757 292.388 50.7672C292.342 50.8212 292.283 50.8624 292.217 50.887C292.151 50.9116 292.079 50.9187 292.01 50.9076Z",
    fill: "#263238"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M312.12 355.856C311.539 355.9 310.961 355.748 310.478 355.424C310.325 355.293 310.207 355.125 310.136 354.936C310.064 354.748 310.04 354.544 310.068 354.344C310.065 354.227 310.096 354.112 310.157 354.012C310.218 353.912 310.307 353.833 310.413 353.782C311.353 353.296 314.085 354.981 314.398 355.176C314.431 355.195 314.457 355.224 314.473 355.259C314.488 355.294 314.492 355.333 314.485 355.37C314.481 355.411 314.465 355.45 314.437 355.481C314.41 355.512 314.374 355.534 314.334 355.543C313.61 355.729 312.867 355.834 312.12 355.856ZM310.856 354.096C310.766 354.088 310.676 354.107 310.597 354.15C310.543 354.15 310.478 354.225 310.467 354.387C310.448 354.521 310.463 354.657 310.51 354.783C310.558 354.91 310.636 355.022 310.737 355.111C311.686 355.543 312.763 355.597 313.75 355.262C312.867 354.689 311.88 354.292 310.845 354.096H310.856Z",
    fill: "#2771bb"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M314.28 355.554H314.183C313.308 355.078 311.602 353.21 311.785 352.314C311.815 352.166 311.894 352.033 312.01 351.936C312.126 351.84 312.272 351.786 312.422 351.784C312.577 351.763 312.734 351.775 312.883 351.819C313.032 351.864 313.17 351.941 313.286 352.044C314.269 352.843 314.474 355.284 314.485 355.402C314.486 355.439 314.477 355.475 314.46 355.507C314.443 355.539 314.418 355.566 314.388 355.586C314.35 355.587 314.312 355.575 314.28 355.554ZM312.563 352.108H312.476C312.217 352.108 312.196 352.26 312.185 352.314C312.077 352.864 313.157 354.279 314.032 354.938C313.975 353.971 313.624 353.044 313.027 352.281C312.899 352.169 312.733 352.108 312.563 352.108Z",
    fill: "#2771bb"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M258.735 353.188C257.342 353.188 254.89 353.134 254.113 352.173C253.99 352.025 253.906 351.849 253.871 351.66C253.835 351.471 253.847 351.276 253.908 351.093C253.931 350.987 253.981 350.889 254.052 350.808C254.124 350.727 254.216 350.665 254.318 350.629C255.398 350.251 258.508 352.519 258.854 352.789C258.887 352.812 258.912 352.847 258.923 352.886C258.935 352.925 258.933 352.967 258.919 353.005C258.914 353.052 258.893 353.096 258.86 353.129C258.826 353.163 258.782 353.184 258.735 353.188ZM254.48 351.028C254.437 351.042 254.4 351.068 254.371 351.102C254.342 351.137 254.324 351.178 254.318 351.223C254.283 351.336 254.276 351.457 254.299 351.574C254.322 351.691 254.373 351.8 254.448 351.892C254.88 352.443 256.24 352.756 258.141 352.767C256.856 351.925 255.128 350.899 254.48 351.039V351.028Z",
    fill: "#2771bb"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M258.735 353.189C258.686 353.208 258.632 353.208 258.584 353.189C257.655 352.562 255.97 350.402 256.283 349.484C256.359 349.268 256.564 349.02 257.115 349.052C257.322 349.061 257.524 349.113 257.71 349.204C257.896 349.295 258.061 349.424 258.195 349.581C259.113 350.661 258.951 352.94 258.94 353.037C258.938 353.072 258.927 353.104 258.908 353.133C258.889 353.161 258.863 353.184 258.832 353.199L258.735 353.189ZM256.856 349.441C256.705 349.441 256.672 349.549 256.661 349.581C256.478 350.132 257.59 351.795 258.508 352.584C258.584 351.616 258.353 350.649 257.849 349.819C257.756 349.706 257.641 349.614 257.511 349.547C257.381 349.48 257.239 349.44 257.093 349.43C257.014 349.416 256.933 349.419 256.856 349.441Z",
    fill: "#2771bb"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M288.479 127.134L285.034 124.671L228.55 203.738L231.995 206.201C242.493 213.313 255.355 216.04 267.836 213.801C280.317 211.562 291.429 204.534 298.8 194.216C306.17 183.898 309.217 171.108 307.289 158.575C305.361 146.042 298.61 134.759 288.479 127.134Z",
    fill: "#fad504"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M288.479 127.134L285.034 124.671L228.55 203.738L231.995 206.201C242.493 213.313 255.355 216.04 267.836 213.801C280.317 211.562 291.429 204.534 298.8 194.216C306.17 183.898 309.217 171.108 307.289 158.575C305.361 146.042 298.61 134.759 288.479 127.134Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M204.821 170.388C204.017 163.707 204.512 156.933 206.279 150.44L207.359 150.721C205.624 157.083 205.139 163.722 205.934 170.269L204.821 170.388Z",
    fill: "#fad504"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M208.094 183.424C207.131 180.966 206.355 178.438 205.772 175.864L206.852 175.626C207.428 178.141 208.19 180.611 209.131 183.013L208.094 183.424Z",
    fill: "#fad504"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M266.611 211.77C292.888 206.356 309.802 180.666 304.389 154.389C298.976 128.112 273.285 111.198 247.008 116.611C220.731 122.024 203.817 147.714 209.23 173.991C214.643 200.269 240.333 217.183 266.611 211.77Z",
    fill: "#fad504"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.402 153.02C259.827 148.647 250.141 151.242 245.767 158.817C241.394 166.392 243.989 176.078 251.564 180.452C255.017 182.446 258.903 182.991 262.531 182.278L263.471 187.059C258.731 187.991 253.64 187.277 249.128 184.672C239.222 178.953 235.828 166.287 241.547 156.381C247.266 146.475 259.933 143.081 269.838 148.8C274.351 151.405 277.515 155.458 279.078 160.028L274.467 161.605C273.27 158.107 270.855 155.014 267.402 153.02Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.646 164.017L238.545 151.834L240.981 147.614L262.083 159.797L259.646 164.017Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.553 170.021L233.672 160.274L236.108 156.054L252.989 165.8L250.553 170.021Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M296.147 160.16C293.885 150.344 287.966 141.759 279.594 136.157C271.223 130.554 261.03 128.355 251.093 130.008C241.156 131.66 232.223 137.04 226.116 145.051C220.009 153.062 217.186 163.101 218.225 173.12C217.012 167.857 216.89 162.4 217.866 157.087C218.842 151.775 220.896 146.718 223.9 142.229C226.905 137.74 230.796 133.913 235.335 130.985C239.875 128.057 244.965 126.089 250.294 125.203C255.622 124.317 261.076 124.531 266.318 125.832C271.561 127.133 276.482 129.494 280.777 132.769C285.073 136.044 288.653 140.164 291.296 144.875C293.939 149.585 295.59 154.787 296.147 160.16Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M328.093 93.8481C329.173 95.2197 330.069 96.4509 330.976 97.7901C331.884 99.1293 332.769 100.415 333.633 101.754C335.35 104.432 336.981 107.154 338.493 109.994C340.005 112.835 341.409 115.74 342.684 118.742L343.612 121.021L344.455 123.365C344.736 124.131 344.973 124.952 345.222 125.751L345.578 126.961L345.675 127.263L345.837 127.922C345.94 128.37 346.012 128.825 346.053 129.283C346.156 130.805 345.954 132.332 345.459 133.776C345.086 134.862 344.597 135.904 344.001 136.886C343.015 138.493 341.872 139.998 340.588 141.379C338.31 143.8 335.836 146.029 333.19 148.043C328.161 151.883 322.805 155.276 317.185 158.184L313.686 152.849C318.211 148.993 322.736 144.932 326.829 140.817C328.818 138.847 330.666 136.74 332.359 134.51C333.078 133.579 333.7 132.576 334.216 131.519C334.376 131.172 334.499 130.81 334.584 130.439C334.584 130.201 334.584 130.158 334.584 130.439C334.568 130.517 334.568 130.598 334.584 130.676C334.581 130.709 334.581 130.741 334.584 130.773L334.486 130.536L334.108 129.585C333.849 128.937 333.622 128.3 333.32 127.663L332.456 125.751L331.538 123.84C330.253 121.302 328.881 118.775 327.391 116.28C325.9 113.785 324.356 111.301 322.747 108.86C321.958 107.629 321.138 106.409 320.317 105.21L317.854 101.7L328.093 93.8481Z",
    fill: "#FFB573"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M327.002 89.2042C334.961 90.8134 341.949 110.275 341.949 110.275L325.339 123.807C325.339 123.807 319.939 113.915 315.532 104.367C310.791 93.967 317.357 87.2602 327.002 89.2042Z",
    fill: "#2771bb"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.002 89.2042C334.961 90.8134 341.949 110.275 341.949 110.275L325.339 123.807C325.339 123.807 319.939 113.915 315.532 104.367C310.791 93.967 317.357 87.2602 327.002 89.2042Z",
    fill: "white"
  }))), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M315.651 152.104L307.076 153.043L312.638 162.353C312.638 162.353 319.766 159.934 318.902 156.024L315.651 152.104Z",
    fill: "#FFB573"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M301.968 157.957L306.925 165.441L312.638 162.353L307.076 153.043L301.968 157.957Z",
    fill: "#FFB573"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetStep2);
export default __webpack_public_path__ + "static/media/budget-step-2.6605857534f3d32cc98992d32da29883.svg";
export { ForwardRef as ReactComponent };